import React from "react";
import { StyleSheet } from "react-native";
import { Text, View } from "./Themed";

export default function LegalDocument({ title, effective, blocks }) {
  return (
    <View style={styles.doc}>
      <Text style={styles.title}>{title}</Text>
      {!!effective && <Text style={styles.effective}>{effective}</Text>}
      {blocks.map((block, i) => {
        switch (block.type) {
          case "h2":
            return <Text key={i} style={styles.h2}>{block.text}</Text>;
          case "h3":
            return <Text key={i} style={styles.h3}>{block.text}</Text>;
          case "p":
            return <Text key={i} style={styles.p}>{block.text}</Text>;
          case "list":
            return (
              <View key={i} style={styles.list}>
                {block.items.map((item, j) => (
                  <View key={j} style={styles.listItem}>
                    <Text style={styles.bullet}>•</Text>
                    <Text style={styles.listText}>{item}</Text>
                  </View>
                ))}
              </View>
            );
          default:
            return null;
        }
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  doc: {
    gap: 10,
  },
  title: {
    fontSize: 26,
    fontWeight: "900",
  },
  effective: {
    fontSize: 12,
    color: "#64748b",
    fontStyle: "italic",
  },
  h2: {
    fontSize: 18,
    fontWeight: "800",
    marginTop: 14,
  },
  h3: {
    fontSize: 15,
    fontWeight: "700",
    marginTop: 6,
  },
  p: {
    fontSize: 14,
    lineHeight: 21,
    color: "#0f172a",
  },
  list: {
    gap: 4,
    paddingLeft: 6,
  },
  listItem: {
    flexDirection: "row",
    gap: 8,
    alignItems: "flex-start",
  },
  bullet: {
    fontSize: 14,
    lineHeight: 21,
    color: "#0f172a",
  },
  listText: {
    flex: 1,
    fontSize: 14,
    lineHeight: 21,
    color: "#0f172a",
  },
});
